<script>
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'

export default {
  mixins: [layout, NavigateMixin],
  emits: ['close-dialog'],
  props: {
    showAlert: {
      type: Boolean,
      default: false,
      required: true,
    },
    connectedDeviceList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      selectedDevice: [],
      deviceList: this.connectedDeviceList,
      DEVICES: { garmin: 'Garmin', fitbit: 'Fitbit' },
    }
  },

  mounted: function() {},
  methods: {
    successCallBack() {
      this.$emit('success', this.selectedDevice)
      this.dismissAlert()
    },
    dismissAlert() {
      this.showAlert = false
      this.$emit('close-alert')
    },
  },
}
</script>

<template>
  <v-row justify="center">
    <v-dialog
      v-model="showAlert"
      scrollable
      persistent
      min-width="200"
      max-width="400"
      no-click-animation
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.dialogMenu"
      :fullscreen="mobile"
    >
      <v-card :class="$style.dialogContainer">
        <v-card-text :class="$style.chatContainer" class="text-center">
          <v-btn
            :ripple="false"
            right
            absolute
            icon
            :class="$style.btnClass"
            @click="dismissAlert"
          >
            <v-icon color="#0476D9">mdi-close</v-icon>
          </v-btn>
          <div :class="$style.queueTextContainer">
            <p :class="$style.titleText"> Select another connected device </p>
          </div>
          <div class="mb-7" :class="$style.textContainer">
            <v-radio-group v-model="selectedDevice">
              <v-radio
                v-for="device in deviceList"
                :key="device.connected_at"
                :label="device.type"
                :value="device"
              ></v-radio>
            </v-radio-group>
          </div>
          <v-row :class="$style.buttonContainer">
            <v-btn
              color="primary"
              class="my-5"
              style="font-size: 14px; text-transform: unset !important"
              rounded
              @click="successCallBack"
              >Update Dashboard</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';

.dialogMenu {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.dialogContainer {
  background-color: #fff !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}
.btnClass {
  top: 10px;
  right: 10px !important;
}
.chatContainer {
  padding-left: 30px !important;
  margin-top: 0;
}

.queueTextContainer {
  margin-top: 50px;
}

.titleText {
  font-size: 20px;
  font-weight: 700;
  line-height: 27px;
  text-align: left;
  letter-spacing: 0;
}

.textContainer {
  display: flex;
  flex-direction: column;
}

.alertText {
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  letter-spacing: 0;
  word-wrap: break-word;
}

.buttonContainer {
  align-items: center;
}

.vl {
  height: 20px;
  border-left: 3px solid rgb(206, 206, 206);
}

.hrRouterLinkTextStrong {
  font-size: 18px;
  font-weight: 800;
}

.hrRouterLinkText {
  font-size: 18px;
}
.privacyText {
  font-size: 15px;
  font-weight: 400;
  line-height: 10px;
  color: #0476d9;
  text-align: left;
  text-decoration: none;
  letter-spacing: 0;
}

@media screen and (max-width: 600px) {
  .chatContainer {
    margin-top: 50%;
  }
}
</style>
